import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProgressBar from './ProgressBar';
import EditableLineItem from './EditableLineItem';
import { formatCAD } from '../../utils/formatCurrency';

export default function CategoryAccordion({ category, items, categoryTotal, budgetMax, onUpdate, onDelete }) {
  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid #E6E9EE',
        '&:before': { display: 'none' },
        borderRadius: '8px !important',
        mb: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ width: '100%', pr: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="subtitle2" fontWeight={600}>
              {category}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              {formatCAD(categoryTotal)}
            </Typography>
          </Box>
          <ProgressBar value={categoryTotal} max={budgetMax} />
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        {items.map((item) => (
          <EditableLineItem
            key={item.id}
            item={item}
            onUpdate={onUpdate}
            onDelete={onDelete}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
